import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  // 予約内容
  const [consent, setconsent] = useState<boolean>(true);
  // ロード
  const [isLoading, setIsLoading]  = useState<Boolean>(false);

  // 退会処理
  function onClickDeleteButton(){
    setIsLoading(true);
    axios.delete(
      '/api/internal/reserves/account_withdraw', {
          data: { institution_key: props.institution_key }
      })
      .then(function (response) {
        setIsLoading(false);
        location.href = (`/${props.institution_key}/reserves/new`);
      })
      .catch(error => {
        setIsLoading(false);
        location.href = (`/${props.institution_key}/reserves/new`);
      }
    );
  }

  // 初期ロード
  useEffect(() =>{
  }, [])
  return(
    <>
      <LoadingOverlay active={isLoading} spinner text='Loading...' >
      <div className="row">
        <div className="col-xs-1  col-sm-1 col-md-2 col-lg-3"/>
        <div className="col-xs-10 col-sm-10 col-md-8 col-lg-6">
          <h3 className="h3">退会画面</h3>
          <div className="form-group">
            <label htmlFor="name">注意事項を確認いただき、よろしければ退会を行ってください。</label>
            <br/>
            <ul className="delete-note">
              <li>退会手続きが完了時点で、予約一覧ページを確認することができなくなります。</li>
              <li>予約自体はキャンセルされないため、予約をキャンセルする際は店舗に連絡をお願い致します。</li>
              <li>電子お薬手帳のアカウントも同時に削除されます。</li>
              <li>退会手続き後にアカウントの復旧はできません。</li>
            </ul>
            <br/>
            <input type="checkbox" id="is_consent" onChange={(e) => setconsent(!e.target.checked)}></input>
            <label htmlFor="is_consent">注意事項に同意する</label>
          </div>
          <div className="col-xs-1 col-sm-1 col-md-2 col-lg-3"/>
          {/* ボタン類 */}
          <div>
            <div className="actions mt40">
                <a className="btn btn-primary pull-left m5" href={`/${props.institution_key}/reserves/new`}>戻る</a>
                <button className="btn btn-danger pull-right m5" disabled={consent} id="open_delete_modal" data-toggle="modal" data-target="#account_delete_modal">退会する</button>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
    {/* 退会確認モーダル */}
      <div className="modal fade" data-backdrop="static" id="account_delete_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
            <div className="sw-modal-icon-question sw-modal-icon">?</div>
            <h2>退会処理を実行します。</h2>
            <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
              本当によろしいですか？
            </div>
            <a type="button"
                className="sw-modal-btn"
                style={{ backgroundColor: 'red', textDecoration: 'none'}}
                data-dismiss="modal"
                onClick={() => onClickDeleteButton()}
            >
            退会する
            </a>
            <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>
    </>
    
  )
}
export default Index;